import App from './App.svelte';

const app = new App({
	target: document.getElementById('root'),
});

export default app;